/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BookedService,
} from '../models/index';
import {
    BookedServiceFromJSON,
    BookedServiceToJSON,
} from '../models/index';

export interface ApiBookedServicesShowShowIdBookerBookerIdGetRequest {
    showId: number;
    bookerId: string;
}

/**
 * 
 */
export class BookedServicesApi extends runtime.BaseAPI {

    /**
     */
    async apiBookedServicesShowShowIdBookerBookerIdGetRaw(requestParameters: ApiBookedServicesShowShowIdBookerBookerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BookedService>>> {
        if (requestParameters['showId'] == null) {
            throw new runtime.RequiredError(
                'showId',
                'Required parameter "showId" was null or undefined when calling apiBookedServicesShowShowIdBookerBookerIdGet().'
            );
        }

        if (requestParameters['bookerId'] == null) {
            throw new runtime.RequiredError(
                'bookerId',
                'Required parameter "bookerId" was null or undefined when calling apiBookedServicesShowShowIdBookerBookerIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/BookedServices/show/{showId}/booker/{BookerId}`.replace(`{${"showId"}}`, encodeURIComponent(String(requestParameters['showId']))).replace(`{${"BookerId"}}`, encodeURIComponent(String(requestParameters['bookerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BookedServiceFromJSON));
    }

    /**
     */
    async apiBookedServicesShowShowIdBookerBookerIdGet(requestParameters: ApiBookedServicesShowShowIdBookerBookerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BookedService>> {
        const response = await this.apiBookedServicesShowShowIdBookerBookerIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
